import { TRootState } from 'Redux/Reducers';

export const getSetupIntent = (state: TRootState) => state.payment.setupIntent;
